import type { Step } from "react-joyride";

/**
 * Versione 1: ritocco di testo (bolletta con luce e gas insieme, consumo
 * stimato, interno dell'indirizzo). Non vale la pena far ripartire il tour a
 * chi l'ha già visto.
 */
export const dettaglioBollettaVersion = 1;

export const dettaglioBollettaSteps: Step[] = [
  {
    target: '[data-tour="bolletta-riepilogo"]',
    title: "Riepilogo",
    content: (
      <p>
        Che fornitura è, di che mese, quanto pesa al mese.{" "}
        <strong>Scarica bolletta</strong> dà il documento originale.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="bolletta-fornitura"]',
    title: "Fornitura",
    content: (
      <p>
        Fornitore attuale, POD per la luce e PDR per il gas, indirizzo — interno
        compreso, quando la bolletta lo riporta. Letti dal documento.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="bolletta-consumi"]',
    title: "Consumi",
    content: (
      <p>
        Consumo annuo in kWh per la luce, in Smc per il gas; una bolletta con
        tutt'e due li mostra entrambi. Se accanto c'è <em>(stima)</em>, il dato
        non era scritto in bolletta ed è stato ricavato: conviene controllarlo.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
];
